import { actions as cmsActions } from 'services/cms-state'
import { getCurrentViewPort } from '../index'

const { CMS_API_SUCCESS, CMS_API_FILE_NOT_FOUND, CMS_API_FAILURE } = cmsActions

export const populateAnalyticsMetadata = (metaData) => {
  const analytics = window.analytics || {}
  const viewPort = getCurrentViewPort()
  window.analytics = { ...analytics, ...metaData, ...{ viewPort } }
}

export const trackSignalEvent = (event, metaData) => {
  // create and dispatch the event
  try {
    const detail = { viewPort: getCurrentViewPort(), ...metaData }
    populateAnalyticsMetadata(metaData)
    const custEvent = new CustomEvent(event, { detail })
    setTimeout(() => window.dispatchEvent(custEvent), 500)
  } catch (error) {
    /* eslint-disable  no-console */
    console.log(`Can't dispatch a custom event because of : ${error}`)
  }
}

// List of actions whitelisted for analytics.
export const whiteList = [
  CMS_API_SUCCESS,
  CMS_API_FILE_NOT_FOUND,
  CMS_API_FAILURE,
]



// WEBPACK FOOTER //
// ./services/utility/analytics/index.js